import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  background: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
  paper: {
    width: "30%",
    [theme.breakpoints.down('lg')]: {
      width: "50%",
    },
    [theme.breakpoints.down('md')]: {
      width: "95%",
    },
  },
  loader: {
    marginTop: "40vh",
  },
  fieldSetStyle: {
    border: 'none',
    display: 'contents',
  },
  legendStyle: {
    padding: "0px",
  }
}));
